import type { FC } from "react";
import { CardArchiveButton } from "../../../moment-card/components/card-archive-button";
import type { FollowUpMomentDetailsLoaderData } from "../../hooks/use-follow-up-moment-details";

export const FollowUpArchiveButton: FC<{
  momentDetails: FollowUpMomentDetailsLoaderData;
  handleArchiveStatusChange: (archived: boolean) => void;
  isDirty: boolean;
}> = ({ momentDetails, handleArchiveStatusChange, isDirty }) => {
  const followUp = momentDetails.followUp;

  if (!followUp) return null;

  return (
    <CardArchiveButton
      id={followUp.moment_id}
      isDeleted={followUp.status === "archived"}
      isArchived={followUp.status === "archived"}
      isActive={followUp.status === "active" && followUp.running}
      unsavedChanges={isDirty}
      status={followUp.status}
      onClicked={handleArchiveStatusChange}
    />
  );
};
